// 작성칸의 서식 거울(docs/design3.md F7).
//
// 첫 화면에 정적으로 싣는다. `lazy` 로 떼 보니 Rolldown 이 이 파일과 첫 청크가 함께 쓰는
// `@maru/protocol` 을 따로 조각으로 쪼개 첫 화면이 오히려 0.5 kB 무거워졌다.

import { marks_of } from '@maru/protocol'
import type { RefObject } from 'react'

/**
 * 거울: 입력칸 **뒤**에 같은 글을 서식대로 그린다. 입력칸은 글자를 비워 커서·선택·한글 조합을
 * 그대로 쥔다(contenteditable 은 조합을 깨뜨린다). 굵기·기울임은 글자 폭을 바꾸지 않는 방법만
 * 쓴다 — 폭이 바뀌면 커서가 글자와 어긋난다. 줄과 조각의 순서가 곧 자리라 번호를 열쇠로 쓴다.
 */
export function Mirror({ text, at }: { text: string; at: RefObject<HTMLDivElement | null> }) {
  return (
    <div ref={at} className="Composer-mirror" aria-hidden>
      {text !== '' &&
        marks_of(text).map((line, i) => (
          <div key={`${i}`} className="ln" data-kind={line.kind}>
            {line.pieces.length === 0 ? (
              <br />
            ) : (
              line.pieces.map((p, j) => (
                <span
                  key={`${j}`}
                  data-mark={p.mark || undefined}
                  data-b={p.bold || undefined}
                  data-i={p.italic || undefined}
                  data-s={p.strike || undefined}
                  data-c={p.code || undefined}
                >
                  {p.text}
                </span>
              ))
            )}
          </div>
        ))}
    </div>
  )
}
